import React from 'react';
import { BookOpen, X } from 'lucide-react';
import type { Book } from '../../../../shared/types/index.js';

interface BookFormHeaderProps {
  initialBook?: Book | null;
  onClose: () => void;
}

export const BookFormHeader: React.FC<BookFormHeaderProps> = ({
  initialBook,
  onClose,
}) => {
  return (
    <div className="p-4 sm:p-5 border-b border-slate-100 flex items-center justify-between bg-slate-50/70">
      <div className="flex items-center gap-2.5">
        <div className="w-9 h-9 rounded-xl bg-indigo-600 text-white flex items-center justify-center shadow-xs">
          <BookOpen className="w-5 h-5" />
        </div>
        <div>
          <h3 className="font-bold text-slate-900 text-base">
            {initialBook ? 'Perbarui Data Buku' : 'Daftarkan Buku & Generate UIBN'}
          </h3>
          <p className="text-xs text-slate-500">
            {initialBook
              ? `Mengedit buku ${initialBook.uibn}`
              : 'Nomor unik UIBN akan di-generate otomatis dengan verifikasi checksum'}
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Tutup Modal"
        className="w-10 h-10 min-w-[44px] min-h-[44px] rounded-xl text-slate-400 hover:text-slate-600 hover:bg-slate-200/60 flex items-center justify-center transition cursor-pointer"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
};
